import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiErrorDetail } from "@/lib/api";

function PasswordForm({ kind }) {
  const [form, setForm] = useState({ current_password: "", current_t_pass: "", new_password: "", new_t_pass: "" });
  const [msg, setMsg] = useState({ type: "", text: "" });
  const [busy, setBusy] = useState(false);
  const isLogin = kind === "login";

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setMsg({ type: "", text: "" });
    try {
      if (isLogin) {
        await api.post("/me/change-password", {
          current_password: form.current_password,
          new_password: form.new_password,
        });
      } else {
        await api.post("/me/change-tpass", {
          current_password: form.current_password,
          current_t_pass: form.current_t_pass,
          new_t_pass: form.new_t_pass,
        });
      }
      setMsg({ type: "ok", text: "Updated successfully." });
      setForm({ current_password: "", current_t_pass: "", new_password: "", new_t_pass: "" });
    } catch (e) {
      setMsg({ type: "err", text: formatApiErrorDetail(e.response?.data?.detail) || e.message });
    } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="lt-card p-6 space-y-4" data-testid={`form-change-${kind}`}>
      <div className="overline">{isLogin ? "Change login password" : "Change transaction password"}</div>
      <div>
        <label className="overline block mb-2">Current login password</label>
        <input type="password" className="lt-input" required value={form.current_password}
          onChange={(e) => setForm({ ...form, current_password: e.target.value })}
          data-testid={`${kind}-current-password`} />
      </div>
      {!isLogin && (
        <div>
          <label className="overline block mb-2">Current transaction password</label>
          <input type="password" className="lt-input" required value={form.current_t_pass}
            onChange={(e) => setForm({ ...form, current_t_pass: e.target.value })}
            data-testid={`${kind}-current-tpass`} />
        </div>
      )}
      <div>
        <label className="overline block mb-2">{isLogin ? "New login password" : "New transaction password"}</label>
        <input type="password" className="lt-input" required minLength={isLogin ? 6 : 4}
          value={isLogin ? form.new_password : form.new_t_pass}
          onChange={(e) => setForm({ ...form, [isLogin ? "new_password" : "new_t_pass"]: e.target.value })}
          data-testid={`${kind}-new-password`} />
      </div>
      {msg.text && <div className={`text-sm ${msg.type === "ok" ? "gold-text" : "text-red-400"}`} data-testid={`${kind}-msg`}>{msg.text}</div>}
      <button className="lt-btn-primary" disabled={busy} data-testid={`${kind}-submit-btn`}>{busy ? "Saving…" : "Update"}</button>
    </form>
  );
}

export default function Profile() {
  const { user } = useAuth();
  return (
    <div className="space-y-8">
      <div>
        <div className="overline">Account</div>
        <h1 className="font-display text-4xl mt-1">Profile</h1>
      </div>
      <div className="lt-card p-6 max-w-2xl">
        <div className="grid grid-cols-2 gap-6">
          <div>
            <div className="overline">User ID</div>
            <div className="font-display text-3xl tabular mt-1">{user?.user_id}</div>
          </div>
          <div>
            <div className="overline">Role</div>
            <div className="font-display text-3xl mt-1 capitalize">{user?.role}</div>
          </div>
          <div>
            <div className="overline">Full name</div>
            <div className="mt-1">{user?.full_name}</div>
          </div>
          <div>
            <div className="overline">Email</div>
            <div className="mt-1">{user?.email}</div>
          </div>
          <div>
            <div className="overline">Mobile</div>
            <div className="mt-1 tabular">{user?.mobile}</div>
          </div>
          <div>
            <div className="overline">Sponsor</div>
            <div className="mt-1 tabular">{user?.sponsor_user_id || "—"}</div>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-4xl">
        <PasswordForm kind="login" />
        <PasswordForm kind="tpass" />
      </div>
    </div>
  );
}
